import {getPlayStoreUrl} from "../../utils";

export const DownloadAppSection = () => {
    const playStoreUrl = getPlayStoreUrl();

    return (
        <section className="oec-download" id="download">
            <div className="oec-section-inner">
            <div className="oec-download-inner">
                <p className="oec-download-kicker">Get the app</p>
                <h2 className="oec-section-title">Download On Energy Connect</h2>
                <p className="oec-download-copy">
                    Jobs, companies and marketplace access on your phone. Available on Google Play now.
                    The App Store release is coming soon.
                </p>
                <div className="oec-download-badges">
                    {playStoreUrl ? (
                        <a
                            className="oec-store-mark"
                            href={playStoreUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="fab fa-google-play" aria-hidden="true"/>
                            <span>
                                <small>Get it on</small>
                                Google Play
                            </span>
                        </a>
                    ) : (
                        <span className="oec-store-mark is-disabled">
                            <i className="fab fa-google-play" aria-hidden="true"/>
                            <span>
                                <small>Get it on</small>
                                Google Play
                            </span>
                        </span>
                    )}
                    <span className="oec-store-mark is-soon" aria-disabled="true">
                        <i className="fab fa-apple" aria-hidden="true"/>
                        <span>
                            <small>Coming soon on the</small>
                            App Store
                        </span>
                    </span>
                </div>
            </div>
            </div>
        </section>
    );
};
